'use client';

import Box from '@mui/material/Box';
import ListItem, { type ListItemProps } from '@mui/material/ListItem';
import ListItemButton, { type ListItemButtonProps } from '@mui/material/ListItemButton';
import { useTranslations } from 'next-intl';

import { type NavLabelKey } from '@/config/navigation.config';
import { Link } from '@/i18n/navigation';

import styles from './NavLinkItem.module.scss';

interface NavLinkItemProps {
  href: string;
  labelKey: NavLabelKey;
  isActive: boolean;
  children?: React.ReactNode;
  listItemProps?: Omit<ListItemProps, 'children'>;
  listItemButtonProps?: Pick<ListItemButtonProps, 'aria-haspopup' | 'aria-expanded'>;
}

const NavLinkItem = ({
  href,
  labelKey,
  isActive,
  children,
  listItemProps = {},
  listItemButtonProps = {},
}: NavLinkItemProps) => {
  const t = useTranslations('common');

  return (
    <ListItem disablePadding {...listItemProps}>
      <ListItemButton
        component={Link}
        href={href as '/'}
        classes={{ root: styles.navLinkRoot }}
        className={`${styles.navLink} ${isActive ? styles.active : ''}`}
        disableRipple
        {...listItemButtonProps}
      >
        {isActive && <Box component="span" className={styles.activeDot} />}
        {children ?? t(labelKey)}
      </ListItemButton>
    </ListItem>
  );
};

export default NavLinkItem;
